export default "__VITE_ASSET__p5Ee3aqL__"